import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { DocumentsService } from '@app/app/services/documents.service';
import { environment } from '@app/environments/environment';

@Component({
  selector: 'app-document-preview',
  templateUrl: 'document-preview.component.html',
  imports: [

  ],
})
export class DocumentPreviewComponent implements OnInit, OnDestroy {
  @Input({required: true}) documentId: number;
  documentDataUrl;
  documentSub;

  constructor(
    private documentService: DocumentsService,
    private domSanitizer: DomSanitizer,
  ) { }

  ngOnInit() {
    const url = `${environment.apiUrl}/document/${this.documentId}?stream=1`;
    this.documentSub =  this.documentService.getDocumentDataBlob(url).subscribe((response: Blob) => {
      const fileURL = URL.createObjectURL(response);
      this.documentDataUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(`${fileURL}#zoom=100`)
    });
  }

  ngOnDestroy() {
    this.documentSub.unsubscribe();
    if (this.documentDataUrl) {
      URL.revokeObjectURL(this.documentDataUrl.toString());
    }
  }
}
